import {Occupancy} from '@deliveriesondemand/dod-data';
import {Component} from 'react';
import moment from 'moment';

import {NumberInput} from './NumberInput';
import {Control, ControlGroup} from './Control';
import {RadioGroup, Radio} from '-/components/fields/RadioGroup';
import {isMobile} from '-/util/util';
import Legend from '-/components/fields/Legend';

class OccupancyInput extends Component {
    static defaultProps = {
        onChange: () => {},
        onTypeChange: () => {},
        onMonthlyPaymentChange: () => {},
        onAdditionalDetailsChange: () => {},
        onYearsAtAddressChange: () => {},
        onMonthsAtAddressChange: () => {}
    };

    constructor(props) {
        super(props);
        const {type, monthlyPayment, additionalDetails, yearsAtAddress, monthsAtAddress} = props;
        this.state = {
            type: type || '',
            monthlyPayment: monthlyPayment || '',
            additionalDetails: additionalDetails || '',
            yearsAtAddress,
            monthsAtAddress
        };
        this.onChange = this.onChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.onMonthlyPaymentChange = this.onMonthlyPaymentChange.bind(this);
        this.onAdditionalDetailsChange = this.onAdditionalDetailsChange.bind(this);
        this.onYearsAtAddressChange = this.onYearsAtAddressChange.bind(this);
        this.onMonthsAtAddressChange = this.onMonthsAtAddressChange.bind(this);
    }

    getErrors() {
        const {dob} = this.props;
        const {type, yearsAtAddress, monthsAtAddress} = this.state;
        const {payment} = this.refs;
        let errs = [];
        if (type === 'own' || type === 'renting') {
            if (!payment.value) {
                errs.push('Monthly housing payment is empty');
            }
        }
        if (!type || type === 'label') {
            errs.push('Occupancy type is empty');
        }
        if (!yearsAtAddress && !monthsAtAddress) {
            errs.push('Years and months resided are empty');
        } else if (dob) {
            const moveInDate = moment().subtract(yearsAtAddress || 0, 'years').subtract(monthsAtAddress || 0, 'months');
            const dobDate = moment(dob);

            if (dobDate.isValid() && moveInDate.isBefore(dobDate)) {
                errs.push('Move in date is before date of birth');
            }
        }
        return errs;
    }

    getExtraInfo() {
        const {type, monthlyPayment, additionalDetails} = this.state;
        switch (type) {
            case 'own':
            case 'renting':
                return (
                    <Control>
                        <NumberInput
                            ref="payment"
                            label="Monthly Payment"
                            placeholder="$XXX"
                            value={monthlyPayment}
                            onChange={this.onMonthlyPaymentChange} />
                    </Control>
                );
            case 'other':
                return (
                    <Control>
                        <textarea
                            ref="description"
                            label="Additional Details"
                            placeholder="Enter Additional Information Here..."
                            value={additionalDetails}
                            onChange={this.onAdditionalDetailsChange} />
                    </Control>
                );
        }
        return null;
    }

    componentWillReceiveProps(nextProps) {
        const {type, monthlyPayment, additionalDetails, yearsAtAddress = '', monthsAtAddress = ''} = nextProps;
        this.setState({
            type,
            monthlyPayment,
            additionalDetails,
            yearsAtAddress,
            monthsAtAddress
        });
    }

    onMonthlyPaymentChange(value) {
        this.setState({
            monthlyPayment: value
        }, () => {
            this.props.onMonthlyPaymentChange(value);
            this.onChange();
        });
    }

    onAdditionalDetailsChange(e) {
        const {value} = e.target;
        this.setState({
            additionalDetails: value
        }, () => {
            this.props.onAdditionalDetailsChange(value);
            this.onChange();
        });
    }

    onYearsAtAddressChange(value) {
        this.setState({
            yearsAtAddress: value
        }, () => {
            this.props.onYearsAtAddressChange(value);
            this.onChange();
        });
    }

    onMonthsAtAddressChange(value) {
        this.setState({
            monthsAtAddress: value
        }, () => {
            this.props.onMonthsAtAddressChange(value);
            this.onChange();
        });
    }

    onTypeChange(e) {
        const {value, checked} = e.target;
        if (checked) {
            this.setState({
                type: value
            }, () => {
                this.props.onTypeChange(value);
                this.onChange();
            });
        }
    }

    onChange() {
        const {state} = this;
        this.props.onChange(state);
    }

    render() {
        const {type, isCoApplicant, yearsAtAddress = '', monthsAtAddress = ''} = this.state;
        const labelWidth = 200;
        return (
            <ControlGroup labelWidth={labelWidth}>
                <Legend>Residence Info</Legend>
                <p className="info">Please tell us some more information about where you live.</p>
                {isCoApplicant ? null : (
                    <Control>
                        <NumberInput
                            label="Years resided"
                            placeholder="X Years"
                            value={yearsAtAddress}
                            onChange={this.onYearsAtAddressChange}
                        />
                    </Control>
                )}
                {isCoApplicant ? null : (
                    <Control>
                        <NumberInput
                            label="Months resided"
                            placeholder="X Months"
                            value={monthsAtAddress}
                            onChange={this.onMonthsAtAddressChange}
                        />
                    </Control>
                )}
                <RadioGroup vertical={isMobile()} label="Residence Status" labelWidth={labelWidth}>
                    {Object.keys(Occupancy).map(key => {
                        const value = Occupancy[key];
                        return (
                            <Radio
                                name="occupancyType"
                                key={key}
                                id={`occupancyType-${key}`}
                                value={key}
                                label={value}
                                checked={type === key}
                                onChange={this.onTypeChange} />
                        );
                    })}
                </RadioGroup>
                {this.getExtraInfo()}
            </ControlGroup>
        );
    }
}

export default OccupancyInput;
